import React, { useState, useEffect } from 'react';
import axios from 'axios';
//import { useAuth } from '../contexts/AuthContext';
import API from '../apiConfig';

const PostTypeManager = () => {
  const [postTypes, setPostTypes] = useState([]);
  const [newPostType, setNewPostType] = useState({ type_name: '' });
  const [editingPostType, setEditingPostType] = useState(null);
  const [error, setError] = useState('');
  //const auth = useAuth() || {}; // Provide a default empty object if auth is null

  useEffect(() => {
    fetchPostTypes();
  }, []);

  const fetchPostTypes = async () => {
    try {
      const response = await axios.get(API.postTypes.fetchAll);
      setPostTypes(response.data);
    } catch (err) {
      setError('Failed to fetch post types');
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
        const token = localStorage.getItem('token');
      await axios.post(API.postTypes.create, newPostType, {
        headers: { Authorization: `Bearer ${token || ''}` }
      });
      setNewPostType({ name: '', description: '' });
      fetchPostTypes();
    } catch (err) {
      setError('Failed to create post type');
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
        const token = localStorage.getItem('token');
      await axios.put(API.postTypes.update(editingPostType.id), editingPostType, {
        headers: { Authorization: `Bearer ${token || ''}` }
      });
      setEditingPostType(null);
      fetchPostTypes();
    } catch (err) {
      setError('Failed to update post type');
    }
  };

  const handleDelete = async (id) => {
    try {
        const token = localStorage.getItem('token');
      await axios.delete(API.postTypes.delete(id), {
        headers: { Authorization: `Bearer ${token || ''}` }
      });
      fetchPostTypes();
    } catch (err) {
      setError('Failed to delete post type');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (editingPostType) {
      setEditingPostType({ ...editingPostType, [name]: value });
    } else {
      setNewPostType({ ...newPostType, [name]: value });
    }
  };

  const isAdmin = true; //auth.user?.type === 1;

  return (
    <div className="container mt-4">
      <h2>Manage Post Types</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      
      {isAdmin && (
        <form onSubmit={editingPostType ? handleUpdate : handleCreate} className="mb-4">
          <div className="mb-3">
            <label htmlFor="type_name" className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              id="type_name"
              name="type_name"
              value={editingPostType ? editingPostType.type_name : newPostType.type_name}
              onChange={handleInputChange}
              required
            />
          </div>
          {/* <div className="mb-3">
            <label htmlFor="description" className="form-label">Description</label>
            <textarea
              className="form-control"
              id="description"
              name="description"
              value={editingPostType ? editingPostType.description : newPostType.description}
              onChange={handleInputChange}
              required
            />
          </div> */}
          <button type="submit" className="btn btn-primary">
            {editingPostType ? 'Update Post Type' : 'Create Post Type'}
          </button>
          {editingPostType && (
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={() => setEditingPostType(null)}
            >
              Cancel Edit
            </button>
          )}
        </form>
      )}

      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            {/* <th>Description</th> */}
            {isAdmin && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {postTypes.map((postType) => (
            <tr key={postType.id}>
              <td>{postType.type_name}</td>
              {/* <td>{postType.description}</td> */}
              {isAdmin && (
                <td>
                  <button className="btn btn-sm btn-info mr-2" onClick={() => setEditingPostType(postType)}>
                    Edit
                  </button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(postType.id)}>
                    Delete
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PostTypeManager;
